import { FacebookIcon } from '@/components/svg/facebook-icon-new/facebook-icon'
import { InstagramIcon } from '@/components/svg/instagram-icon/instagram-icon'
import { PinterestIcon } from '@/components/svg/pinterest-icon/pinterest-icon'
import { RMWLogo } from '@/components/svg/rmw-logo/rmw-logo'
import { TiktokIcon } from '@/components/svg/tiktok-icon/tiktok-icon'
import { Image } from '@/components/v2/atoms/image/image'
import { PROD_URL, ROUTES } from '@/constants'
import Link from 'next/link'
import { FOOTER_SOCIALS, GOOGLE_PREFERRED_SOURCE_URL } from '../footer-data'
import s from './footer-brand-block.module.scss'

const SOCIAL_ICON_BY_NAME = {
  Instagram: InstagramIcon,
  TikTok: TiktokIcon,
  Facebook: FacebookIcon,
  Pinterest: PinterestIcon,
} as const

export const FooterBrandBlock = () => {
  return (
    <div className={s.container}>
      <Link
        href={ROUTES.HOME}
        aria-label="Go to Rock My Wedding Homepage"
        className={s.logoLink}
      >
        <RMWLogo />
      </Link>
      <div className={s.socials}>
        {FOOTER_SOCIALS.map((social) => {
          const Icon = SOCIAL_ICON_BY_NAME[social.name]
          return (
            <Link
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={social.name}
              className={s.socialLink}
            >
              <Icon />
            </Link>
          )
        })}
      </div>
      <Link
        href={GOOGLE_PREFERRED_SOURCE_URL}
        target="_blank"
        rel="noreferrer noopener"
        className={s.badgeLink}
      >
        <Image
          src={`${PROD_URL}/images/google_preferred_source_badge_light_en.png`}
          alt="Add Rock My Wedding as a preferred source on Google"
          width={170}
          height={54}
          className={s.badgeImage}
          noOptimize
        />
      </Link>
    </div>
  )
}
